import { smaFromBars } from '../indicators/sma';
import { atrFromBars } from '../indicators/atr';

export const maCrossover = {
  id: 'ma-crossover',
  name: 'MA Cross',
  indicators: ['SMA', 'SMA', 'ATR'],
  chartOverlays(params = {}) {
    return [
      { key: 'fast', label: `Fast SMA ${params.fast ?? 9}`, colorKey: 'primary', lineWidth: 1 },
      { key: 'slow', label: `Slow SMA ${params.slow ?? 21}`, colorKey: 'secondary', lineWidth: 1 },
    ];
  },
  paramSchema: [
    { key: 'fast', label: 'Fast SMA', type: 'number', default: 9, min: 1, max: 200, step: 1 },
    { key: 'slow', label: 'Slow SMA', type: 'number', default: 21, min: 2, max: 400, step: 1 },
    { key: 'atrPeriod', label: 'ATR period', type: 'number', default: 14, min: 2, max: 200, step: 1 },
    { key: 'atrMultiple', label: 'ATR stop', type: 'number', default: 1.5, min: 0.1, max: 10, step: 0.1 },
    { key: 'tp2R', label: 'TP2 R', type: 'number', default: 2, min: 0.5, max: 10, step: 0.1 },
  ],

  prepare(bars, params) {
    const fastPeriod = Math.min(params.fast, params.slow);
    const slowPeriod = Math.max(params.fast, params.slow);
    return {
      ind: {
        fast: smaFromBars(bars, fastPeriod),
        slow: smaFromBars(bars, slowPeriod),
        atr: atrFromBars(bars, params.atrPeriod),
      },
    };
  },

  explain(ctx) {
    const { i, ind } = ctx;
    const fast = ind.fast?.[i];
    const slow = ind.slow?.[i];
    const prevFast = ind.fast?.[i - 1];
    const prevSlow = ind.slow?.[i - 1];
    const crossedUp = Number.isFinite(prevFast) && Number.isFinite(prevSlow) && prevFast <= prevSlow && fast > slow;
    const crossedDown = Number.isFinite(prevFast) && Number.isFinite(prevSlow) && prevFast >= prevSlow && fast < slow;
    return [
      { id: 'ready', label: 'MAs ready', pass: Number.isFinite(fast) && Number.isFinite(slow) },
      { id: 'fast-gt-slow', label: 'Fast > slow', pass: Number.isFinite(fast) && Number.isFinite(slow) && fast > slow },
      { id: 'cross', label: 'Crossed', pass: crossedUp || crossedDown },
    ];
  },

  onBar(ctx) {
    const { i, ind, params, position } = ctx;
    const fast = ind.fast?.[i];
    const slow = ind.slow?.[i];
    const prevFast = ind.fast?.[i - 1];
    const prevSlow = ind.slow?.[i - 1];
    const atr = ind.atr?.[i];
    if (![fast, slow, prevFast, prevSlow, atr].every(Number.isFinite)) return [];

    const crossedUp = prevFast <= prevSlow && fast > slow;
    const crossedDown = prevFast >= prevSlow && fast < slow;
    if (!crossedUp && !crossedDown) return [];

    const side = crossedUp ? 'long' : 'short';
    if (position && position.side === side) return [];
    return [{
      type: 'enter',
      orderType: 'market',
      side,
      atr,
      atrMultiple: params.atrMultiple,
      takeProfits: [
        { id: 'tp1', rMultiple: 1, qtyPct: 0.5 },
        { id: 'tp2', rMultiple: params.tp2R, qtyPct: 0.5 },
      ],
    }];
  },
};

export default maCrossover;
